import { render, staticRenderFns } from "./BuscaVehiculo.vue?vue&type=template&id=88504436&"
import script from "./BuscaVehiculo.vue?vue&type=script&lang=ts&"
export * from "./BuscaVehiculo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports